/**
 * Pagination component
 * 
 * @params pages num
 * @params currentPage num
 * @params setCurrentPage func
 * @returns JSX
 */
const PaginationTable = ({ pages, currentPage, setCurrentPage }) => {

    const pageNumbers = [...Array(pages + 1).keys()].slice(1)

    /**
     * Method switch to next page
     */
    const nextPage = () => {
        if (currentPage !== pages) setCurrentPage(currentPage + 1)
    }
    /**
     * Method switch to the previous page
     */
    const prevPage = () => {
        if (currentPage !== 1) setCurrentPage(currentPage - 1)
    }

    return (
        <nav>
            <ul className="pagination justify-content-center">
                <li className="page-item">
                    <button
                        onClick={prevPage}
                        className="page-link shadow-none"
                    >
                        &laquo;
                    </button>
                </li>
                {
                    pageNumbers?.map(pgNumber => (
                        <li
                            key={pgNumber}
                            className={`page-item ${currentPage === pgNumber ? "active" : ''} `}
                        >
                            <button
                                style={{ "zIndex": "0" }}
                                className="page-link shadow-none"
                                onClick={() => setCurrentPage(pgNumber)}
                            >
                                {pgNumber}
                            </button>
                        </li>
                    ))
                }
                <li className="page-item">
                    <button
                        onClick={nextPage}
                        className="page-link shadow-none"
                    >
                        &raquo;
                    </button>
                </li>
            </ul>
        </nav>
    )
}

export default PaginationTable;